module.exports = __webpack_public_path__ + "static/media/sl.2b040d07.svg";